export default __webpack_public_path__ + "static/media/secured@2x.c9e3b5ae.png";